import yachtEquipmentPackCategoriesApiService from '@/services/api/YachtEquipmentPackCategories'

const emptyFilters = {
  name: null
}

const emptyModel = {
  name: null,
  color: null,
  required: true,
  is_cdr: false,
  is_navigare_option: false,
  is_yard_equipment: false,
  order: null
}

class YachtEquipmentPackCategory {
  constructor() {
    this.api = yachtEquipmentPackCategoriesApiService
    this.emptyModel = emptyModel
    this.emptyFilters = emptyFilters
  }
}

const yachtEquipmentPackCategory = new YachtEquipmentPackCategory()

export default yachtEquipmentPackCategory
